import { Form, Field, useFormState } from 'react-final-form';
import { Dropdown } from 'primereact/dropdown';
import { FloatLabel } from 'primereact/floatlabel';
import { classNames } from 'primereact/utils';
import { InputMask } from 'primereact/inputmask';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { ToggleButton } from 'primereact/togglebutton';

import countries from '../data/country.json'
const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) ? <small className="p-error">{meta.error}</small> : <small>&nbsp;</small>;
};
const AddressZipField = ({ labels }) => {
    const { values } = useFormState();

    return <Field name="address_zip">
        {({ input, meta }) => (
            <div className="field">
                <FloatLabel>
                    <InputMask
                        style={{ textAlign: 'center' }}
                        disabled={!values['address_country']}
                        mask={countries[values['address_country']] ? "9".repeat(countries[values['address_country']].zipCodeLength) : ""}
                        placeholder={countries[values['address_country']] ? "X".repeat(countries[values['address_country']].zipCodeLength) : ""}
                        {...input}
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.zipCode}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
        )}
    </Field>;
};
const AddressStreetField = ({ labels }) => {
    const { values } = useFormState();
    return <Field name={"address_street"}
        render={({ input, meta }) => {
            return <div className="field">
                <FloatLabel>
                    <InputText
                        disabled={!values['address_country']}
                        {...input}
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.street}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
        }
        } />
};
const AddressNumberField = ({ labels }) => {
    const { values } = useFormState();
    return <Field name={"address_number"}
        render={({ input, meta }) => {
            return <div className="field">
                <FloatLabel>
                    <InputText
                        disabled={!values['address_country']}
                        {...input}
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                        keyfilter={"alphanum"}
                    />
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.streetNumber}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
        }
        } />
};
const AddressCityField = ({ labels }) => {
    const { values } = useFormState();
    return <Field name={"address_city"}
        render={({ input, meta }) => {
            return <div className="field">
                <FloatLabel>
                    <InputText
                        disabled={!values['address_country']}
                        {...input}
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.city}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
        }}
    />
};
const AddressCountryField = ({ labels, countries }) => {
    return <Field
        name={"address_country"}
        render={({ input, meta }) => (
            <div className="field">
                <FloatLabel>
                    <Dropdown
                        {...input}
                        optionLabel="name"
                        optionValue="value"
                        filter
                        scrollHeight="300px"
                        options={Object.entries(countries).map(([code, country]) => { return { 'name': (country.emoji + " " + country.name[labels.langCode]), 'value': code } })}
                        placeholder='Country'
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.country}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
        )}
    />
};
const TempGuardianField = ({ labels }) => {
    const { values } = useFormState();
    return <Field name={"guardian"}
        render={({ input, meta }) => {
            return <div className="field">
                <FloatLabel>
                    <InputText
                        disabled={values['takesPart']}
                        {...input}
                        className={classNames({ 'p-invalid': isFormFieldValid(meta) })}
                    />
                    <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                        {labels.tempGuardian}
                    </label>
                </FloatLabel>
                {getFormErrorMessage(meta)}
            </div>
        }
        } />
}
const HomeAddress = ({ familyMember, sfd, labels, fd }) => {
    return <Form onSubmit={(data, form) => {
        for (let key in data)
            familyMember[key] = data[key];
        familyMember.currentStep += data.takesPart ? 1 : 3;
        if (familyMember.takesPart === false) {
            delete familyMember.takesBus;
            delete familyMember.busLine;
            delete familyMember.dropOffStop;
            delete familyMember.getAboardStop;
            delete familyMember.chapitre;
            delete familyMember.chapitreRegion;
        }
        sfd(familyMember);
    }
    }
        initialValues={{
            ...familyMember,
            takesBus: familyMember.takesBus || true,
        }}
        validate={(data) => {
            let error = {};
            let requiredFields = ["address_country", "address_zip", "address_city", "address_street", "address_number"];
            for (let f of requiredFields)
                if (!data[f] && data[f] !== false)
                    error[f] = labels['This field is required.'];
            if (data.address_country && data.address_zip && data.address_zip.replaceAll(' ', '').toString().length !== countries[data.address_country].zipCodeLength)
                error["address_zip"] = labels['Invalid ZIP code'];
            if (data["address_city"] && data["address_city"].includes(";"))
                error["address_city"] = labels['City name cannot contain semicolons(;)'];
            if (data["address_street"] && data["address_street"].includes(";"))
                error["address_street"] = labels['Street name cannot contain semicolons(;)'];
            if (!data.takesPart && !data.guardian)
                error["guardian"] = labels['This field is required.'];
            if (!data.takesPart && (fd.filter(f => f.isSpouse === false).length === 0))
                error["takesPart"] = labels.atleastOneChildIfOneTakesNoPart;
            //REMOVED, AS NOT REALLY NECESSARY AND TOO HARD TO ENSURE CONSISTENCY
            /*if (!data.takesPart && (fd.filter(f => f.isSpouse).length === 1))
              error["takesPart"] = 'If you do not take part, you must register your spouse as main participant.';
            */
            return error;
        }}
        render={({ handleSubmit }) => (
            <>
                <Fieldset legend={labels.participation} className="p-mb-4">
                    <div className="grid ui-fluid ">
                        <div className="col-12 md:col-6">
                            <Field name="takesPart"
                                type="checkbox"

                                render={({ input, meta }) => {
                                    return <div className="field">
                                        <label className={classNames({ 'p-error': isFormFieldValid(meta) })}>
                                            {labels.takesPart}
                                        </label>
                                        <ToggleButton {...input}
                                            onLabel={labels.yes}
                                            className={classNames({ 'p-error': isFormFieldValid(meta) })}
                                            offLabel={labels.no}
                                            onIcon="pi pi-check"
                                            offIcon="pi pi-times" />
                                        <br />
                                        {getFormErrorMessage(meta)}
                                    </div>

                                }
                                } />
                        </div>
                        <div className="col-12 md:col-6">
                            <TempGuardianField labels={labels} />
                        </div>
                    </div>
                </Fieldset>
                <Fieldset legend={labels.homeAddress} className="p-mb-4">
                    <div className="grid ui-fluid ">
                        <div className="col-12 md:col-12 flex justify-content-center align-items-center">
                            <AddressCountryField labels={labels} countries={countries} />
                        </div>
                    </div>
                    <div className="grid ui-fluid ">
                        <div className="col-12 md:col-6">
                            <AddressZipField labels={labels} />
                        </div>
                        <div className="col-12 md:col-6">
                            <AddressCityField labels={labels} />
                        </div>
                    </div>
                    <div className="grid ui-fluid ">
                        <div className="col-12 md:col-6">
                            <AddressStreetField labels={labels} />
                        </div>
                        <div className="col-12 md:col-6">
                            <AddressNumberField labels={labels} />
                        </div>
                    </div>
                </Fieldset>
                <div className="flex py-4 gap-2">
                    <Button
                        type="button"
                        label={labels.back}
                        severity="secondary"
                        icon="pi pi-arrow-left"
                        onClick={() => { familyMember.currentStep--; sfd(familyMember) }} />
                    <Button
                        type="button"
                        label={labels.next}
                        icon="pi pi-arrow-right"
                        iconPos="right"
                        onClick={handleSubmit} />
                </div>
            </>
        )}
    />;
};

export default HomeAddress;